var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDeferred)?_c('N8Dialog',{staticClass:"video-modal-fullscreen",attrs:{"show":_vm.isDeferred}},[_c('DeferredPage',{on:{"onPlayVideo":_vm.playDeferredVideo}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }